import { fetchData } from '../containers/GamedayMiniAppContainer';
import { routes as liveRoutes } from '@gameday/components/Live/containers/LiveMiniHomeDataContainer';
import { routes as finalRoutes } from '@gameday/components/Final/containers/FinalMiniHomeDataContainer';
import { routes as previewRoutes } from '@gameday/components/Preview/containers/PreviewMiniHomeDataContainer';
import { routes as pitchFxRoutes } from '@gameday/components/PitchFx/PitchFxDataContainer';
import { routes as gamecontextRoutes } from '@gameday/components/GameContext/GameContextDataContainer';
import hashParams from './hashParams';

const { id } = hashParams();
const routesMap = {
    strikezone: [
        ...pitchFxRoutes
    ],
    default: [
        ...previewRoutes,
        ...liveRoutes,
        ...finalRoutes,
        ...gamecontextRoutes
    ],
    gamecontext: [
        ...gamecontextRoutes
    ]

};
const dataRouterConfig = {
    routes: [
        {
            exact: false,
            path: '/',
            routes: routesMap[id] || routesMap.default,
            fetchData: (state) => fetchData(state)
        }
    ]
};

export default dataRouterConfig;
